import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { TextContent } from '../../../pages/common/data-privacy/data-privacy.interface';

@Component({
  selector: 'app-list',
  imports: [],
  templateUrl: './list.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ListComponent {
  isEnumerated = input<boolean>(false);
  items = input.required<TextContent[]>();
}
